import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FreightExchangeRateActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Freight/ExchangeRateDaily/ExchangeRateDailyBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingExchangeRate"
				RenderedComponent={this.RenderedComponent}
				context="AccountingExchangeRate"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FreightExchangeRateActivity)
